module.exports = __webpack_public_path__ + "img/41bb73c.png";